import { API_JWT_BASE_URL } from '../http'

export const SEARCH_OTAP_REGISTRATIONS_API = `${API_JWT_BASE_URL}/OtapRegistrations/search`
export const GET_OTAP_REGISTRATION_ERROR_DETAIL_API = `${API_JWT_BASE_URL}/OtapRegistrations/errordetailslog`

export const OTAP_REGISTRATIONS_QUERY_KEYS = {
  SEARCH_OTAP_REGISTRATIONS: 'SEARCH_OTAP_REGISTRATIONS',
  GET_OTAP_REGISTRATION_ERROR_DETAIL: 'GET_OTAP_REGISTRATION_ERROR_DETAIL'
}
